import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withKeys as _withKeys, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "justify-left full-width"
}
const _hoisted_2 = { class: "row justify-left no-wrap" }
const _hoisted_3 = {
  key: 0,
  class: "q-mr-xs address-inline-wrap"
}
const _hoisted_4 = { style: {"word-break":"keep-all","white-space":"nowrap"} }
const _hoisted_5 = {
  key: 1,
  class: "row justify-left full-width q-py-xs no-wrap"
}
const _hoisted_6 = { class: "col q-pl-sm" }
const _hoisted_7 = { class: "row justify-left full-width q-pt-none no-wrap" }
const _hoisted_8 = { class: "items-center" }
const _hoisted_9 = { class: "row no-wrap" }
const _hoisted_10 = { class: "row q-mx-sm no-wrap minw-selector" }
const _hoisted_11 = {
  key: 4,
  class: "q-py-none"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 2,
  class: /*@__PURE__*/_normalizeClass(['cursor-pointer', 'q-my-none', 'q-pt-xs' ])
}
const _hoisted_14 = { class: "row justify-left full-width no-wrap" }
const _hoisted_15 = { key: 3 }
const _hoisted_16 = {
  key: 4,
  class: "row"
}
const _hoisted_17 = {
  key: 5,
  class: /*@__PURE__*/_normalizeClass(['cursor-pointer', 'q-my-none', 'q-pt-xs'])
}
const _hoisted_18 = { class: "row justify-left full-width q-pt-none no-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_address_selector_refactored = _resolveComponent("address-selector-refactored")!
  const _component_q_option_group = _resolveComponent("q-option-group")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_aux_selector = _resolveComponent("aux-selector")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_recursive_selector = _resolveComponent("recursive-selector")!
  const _component_q_btn_toggle = _resolveComponent("q-btn-toggle")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_date_range_display_item = _resolveComponent("date-range-display-item")!
  const _component_formula_selector = _resolveComponent("formula-selector")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_ctx.modelType !== 4)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (_ctx.theModel.Positive !== undefined)
            ? (_openBlock(), _createBlock(_component_q_toggle, {
                key: 0,
                modelValue: _ctx.theModel.Positive,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.theModel.Positive) = $event)),
                class: "q-pa-none toggle-checkbox q-mr-none unset-items-center",
                "checked-icon": "add",
                color: "primary",
                label: "",
                dense: "",
                size: "xs",
                "unchecked-icon": "remove"
              }, null, 8, ["modelValue"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            style: _normalizeStyle(`margin-top: ${_ctx.modelCategory === 6 ? '0' : '2px'};`),
            class: _normalizeClass(["row", { 'address-controls-row no-wrap items-start': _ctx.modelType === 1 && _ctx.modelCategory === 6 }])
          }, [
            (_ctx.modelType === 1 && _ctx.modelCategory === 6)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_address_selector_refactored, {
                    class: "q-mt-xs",
                    modelValue: (_ctx.theModel as SelectionEntityWithRolesFilterSend).Entity,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (((_ctx.theModel as SelectionEntityWithRolesFilterSend).Entity) = $event)),
                    "show-clear": true,
                    "show-delete": false
                  }, null, 8, ["modelValue"])
                ]))
              : _createCommentVNode("", true),
            (!_ctx.isEditing && _ctx.modelCategory !== 6)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: _normalizeClass(["items-center", ['q-my-auto', 'cursor-pointer', 
          { 'text-grey-8': _ctx.modelType === 0 && !(_ctx.modelValue as SelectionTextFilterSend).Value }]]),
                  style: {"word-wrap":"break-word","float":"left","margin-right":"5px"},
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.editElementName && _ctx.editElementName(...args)))
                }, _toDisplayString((_ctx.modelCategory === 1 ? '#' : '')+_ctx.getElementName), 3))
              : _createCommentVNode("", true),
            (_ctx.modelType === 10)
              ? (_openBlock(), _createBlock(_component_q_option_group, {
                  key: 2,
                  dense: "",
                  inline: "",
                  multiple: "",
                  "model-value": _ctx.moveFlagSetConditions.map((el) => el.value),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = (val) => { _ctx.changeMoveFlagModel(val)}),
                  options: _ctx.movementFlagOptions,
                  size: "xs",
                  color: "primary",
                  type: "checkbox"
                }, null, 8, ["model-value", "options"]))
              : _createCommentVNode("", true),
            (_ctx.isEditing && _ctx.modelType === 0)
              ? (_openBlock(), _createBlock(_component_q_input, {
                  key: 3,
                  class: "thin-input full-width",
                  autofocus: "",
                  color: "grey-4",
                  debounce: "500",
                  outlined: "",
                  dense: "",
                  style: {"font-size":"14px !important","padding":"0 !important","margin-top":"-3px"},
                  "hide-bottom-space": "",
                  modelValue: (_ctx.modelValue as SelectionTextFilterSend).Value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (((_ctx.modelValue as SelectionTextFilterSend).Value) = $event)),
                  "auto-save": "",
                  "no-error-icon": "",
                  rules: [(val) => !!val || _ctx.$t('input_name')],
                  onKeydown: [
                    _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.isEditing = false), ["esc"])),
                    _withKeys(_withModifiers(_ctx.saveTextModel, ["stop","prevent"]), ["enter"])
                  ],
                  onBlur: _cache[6] || (_cache[6] = ($event: any) => (_ctx.isEditing = false))
                }, null, 8, ["modelValue", "rules", "onKeydown"]))
              : _createCommentVNode("", true),
            ([1,2,3].includes(_ctx.modelType) && _ctx.modelCategory !== 6)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 4,
                  class: "q-px-none q-mx-none unset-items-center",
                  flat: "",
                  dense: "",
                  "aria-label": _ctx.$t('delete_filter'),
                  icon: "close",
                  size: "sm",
                  tabindex: "-1",
                  color: "grey-8",
                  onClick: _ctx.emitDelete
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, { delay: 1000 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('remove')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["aria-label", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.modelType === 1 && _ctx.modelCategory === 6)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 5,
                  class: "q-px-none q-mx-none unset-items-center address-delete-btn",
                  flat: "",
                  dense: "",
                  "aria-label": _ctx.$t('delete_filter'),
                  icon: "close",
                  size: "sm",
                  tabindex: "-1",
                  color: "grey-8",
                  onClick: _ctx.emitDelete
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_tooltip, { delay: 1000 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('remove')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["aria-label", "onClick"]))
              : _createCommentVNode("", true),
            (_ctx.modelType === 1 && _ctx.roleOptions && _ctx.roleOptions.length)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 6,
                  class: "address-roles-trigger cursor-pointer q-ml-xs text-bold text-grey-8",
                  onClick: _cache[7] || (_cache[7] = ($event: any) => ((_ctx.$refs.roles_select as any).showPopup())),
                  style: {"margin-top":"3px"}
                }, "# "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.modelType === 1 && _ctx.roleOptions && _ctx.roleOptions.length ? _ctx.rolesModel : []), (role, ri) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "row no-wrap address-role-chip",
                key: ri,
                style: {"float":"left","margin-top":"3px"}
              }, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(role.label), 1),
                _createVNode(_component_q_btn, {
                  class: "q-pa-none q-ma-none",
                  style: {"margin-top":"0"},
                  flat: "",
                  dense: "",
                  "aria-label": _ctx.$t('remove'),
                  icon: "close",
                  size: "xs",
                  onClick: () => { _ctx.rolesModel = _ctx.rolesModel.filter((el, index) => index != ri) }
                }, null, 8, ["aria-label", "onClick"])
              ]))
            }), 128))
          ], 6)
        ]),
        (_ctx.modelType === 1 && _ctx.roleOptions && _ctx.roleOptions.length)
          ? (_openBlock(), _createBlock(_component_q_select, {
              key: 0,
              flat: "",
              modelValue: _ctx.rolesModel,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.rolesModel) = $event)),
              class: "no-select-border q-mb-xs",
              "hide-bottom-space": "",
              "fill-input": "",
              multiple: "",
              "label-slot": false,
              "bottom-slots": false,
              dense: "",
              outlined: "",
              style: 'max-width: 40vw; max-height: 0; overflow: hidden;',
              "input-debounce": "500",
              label: "",
              ref: "roles_select",
              "hide-dropdown-icon": true,
              options: _ctx.roleOptions
            }, {
              "no-option": _withCtx(() => [
                _createVNode(_component_q_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_item_section, { class: "text-grey" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('no_data_found')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "options"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_ctx.theModel.Descriptor === 2)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  class: "q-my-none unset-items-center",
                  flat: "",
                  dense: "",
                  round: "",
                  icon: "add",
                  size: "sm",
                  color: "grey-8",
                  style: {"margin-top":"-2px"},
                  "aria-label": _ctx.$t('add_condition')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_menu, {
                      anchor: "top right",
                      self: "bottom left",
                      ref: (el) => { _ctx.set_menu = el },
                      "max-height": "1300px"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_aux_selector, {
                          ref: "aux_selector_set",
                          "model-value": _ctx.conditionsModel.filter((el) => el.listParam),
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = (arg) => { _ctx.onAddStringSet(arg); }),
                          "input-index": 0,
                          "allow-free-input": true,
                          "model-type": 16,
                          "set-id": (_ctx.theModel as SelectionParameterFilterStringSetSend).SetId,
                          "allow-multiple": true,
                          onInputValue: _cache[10] || (_cache[10] = (val) => { _ctx.throttledAdd(val); }),
                          onSelectorClosed: _ctx.hideSetMenu
                        }, null, 8, ["model-value", "set-id", "onSelectorClosed"])
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                }, 8, ["aria-label"]))
              : (_ctx.theModel.Descriptor && _ctx.theModel.Descriptor !== 3)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 1,
                    class: "q-my-none unset-items-center",
                    flat: "",
                    dense: "",
                    round: "",
                    icon: "add",
                    size: "sm",
                    color: "grey-8",
                    style: {"margin-top":"-2px"},
                    onClick: _ctx.addNewCondition,
                    "aria-label": _ctx.$t('add_condition')
                  }, null, 8, ["onClick", "aria-label"]))
                : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                (!_ctx.parentElement && (((_ctx.theModel.Descriptor !== 3 && (!_ctx.conditionsModel || !_ctx.conditionsModel.length)) ||
                (_ctx.theModel.Descriptor === 3 && (!_ctx.conditionsModel[0] || !_ctx.conditionsModel[0].length))) && _ctx.theModel.Positive !== undefined))
                  ? (_openBlock(), _createBlock(_component_q_toggle, {
                      key: 0,
                      modelValue: _ctx.theModel.Positive,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.theModel.Positive) = $event)),
                      class: _normalizeClass(`q-pa-none toggle-checkbox q-mr-none unset-items-center`),
                      style: {"margin-top":"-2px"},
                      "checked-icon": "add",
                      color: "primary",
                      label: "",
                      size: "xs",
                      dense: "",
                      "unchecked-icon": "remove"
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  style: {"word-wrap":"break-word","word-break":"break-all"},
                  class: _normalizeClass([{ 'cursor-pointer': _ctx.theModel.Descriptor }])
                }, [
                  _createTextVNode(_toDisplayString(_ctx.getElementName) + " ", 1),
                  (_ctx.theModel.Descriptor)
                    ? (_openBlock(), _createBlock(_component_q_menu, {
                        key: 0,
                        fit: "",
                        onBeforeShow: _cache[17] || (_cache[17] = (e) => { _ctx.filter_string = '' })
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_q_input, {
                              outlined: "",
                              dense: "",
                              ref: "panel_search_input",
                              color: "white",
                              class: "full-width thin-input q-my-auto",
                              modelValue: _ctx.filter_string,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.filter_string) = $event)),
                              "hide-bottom-space": "",
                              placeholder: _ctx.$t('search_label'),
                              autofocus: "",
                              debounce: "100",
                              onKeydown: [
                                _cache[13] || (_cache[13] = _withKeys(_withModifiers(($event: any) => (_ctx.$refs.rec_selector && (_ctx.$refs.rec_selector as any).trackArrowDown(1)), ["exact","prevent"]), ["down"])),
                                _cache[14] || (_cache[14] = _withKeys(_withModifiers(($event: any) => (_ctx.$refs.rec_selector && (_ctx.$refs.rec_selector as any).trackArrowUp(1)), ["exact","prevent"]), ["up"]))
                              ],
                              onKeyup: _cache[15] || (_cache[15] = _withKeys(($event: any) => (_ctx.$refs.rec_selector && (_ctx.$refs.rec_selector as any).selectCurrent()), ["enter"]))
                            }, null, 8, ["modelValue", "placeholder"]),
                            _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                              class: "q-my-sm q-px-none q-mr-none q-ml-lg",
                              flat: "",
                              dense: "",
                              "aria-label": _ctx.$t('close_selector'),
                              icon: "close",
                              size: "md"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_tooltip, { delay: 1000 }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('close_menu')), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }, 8, ["aria-label"])), [
                              [_directive_close_popup]
                            ])
                          ]),
                          _createVNode(_component_q_separator, { class: "q-my-none q-py-none" }),
                          _createVNode(_component_recursive_selector, {
                            style: {"max-height":"50vh","overflow":"auto"},
                            ref: "rec_selector",
                            elements: _ctx.parameterOptions,
                            "take-ids-only": true,
                            "hide-checkboxes": true,
                            "allow-multiple": false,
                            "element-type": 9,
                            modelValue: _ctx.selectedParameterModel,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.selectedParameterModel) = $event)),
                            "return-type": "chain",
                            "nested-key-name": "FieldFilters",
                            "entity-inside-name": "Parameter",
                            "filter-string": _ctx.filter_string
                          }, null, 8, ["elements", "modelValue", "filter-string"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 2)
              ])
            ]),
            ((_ctx.theModel as any).Connector)
              ? (_openBlock(), _createBlock(_component_q_btn_toggle, {
                  key: 2,
                  modelValue: (_ctx.theModel as any).Connector,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (((_ctx.theModel as any).Connector) = $event)),
                  class: "filter-parameter-toggle q-mr-none",
                  style: {"margin-top":"-1px"},
                  "no-caps": "",
                  unelevated: "",
                  dense: "",
                  "toggle-color": "primary",
                  color: "white",
                  "text-color": "accent",
                  options:  [
            { label: _ctx.$t('or_label'), value: 1 },
            { label: _ctx.$t('and_label'), value: 2 }
          ]
                }, null, 8, ["modelValue", "options"]))
              : _createCommentVNode("", true),
            _createVNode(_component_q_btn, {
              class: "q-px-none q-ml-xs unset-items-center",
              style: _normalizeStyle(`margin-top: ${_ctx.conditionsModel && _ctx.conditionsModel.length ? -2 : -1}px;`),
              flat: "",
              dense: "",
              "aria-label": _ctx.$t('delete_filter'),
              icon: "close",
              size: "sm",
              tabindex: "-1",
              color: "accent",
              onClick: _ctx.emitDelete
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_tooltip, { delay: 1000 }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('remove')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["style", "aria-label", "onClick"])
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conditionsModel, (cond, c_index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: c_index,
              class: "row justify-left full-width q-py-none no-wrap",
              style: _normalizeStyle('max-width: 100%;'+([0].includes((cond as any).CompareType) ? 'max-height: 35px;' : ''))
            }, [
              (_ctx.theModel.Descriptor !== 3)
                ? (_openBlock(), _createBlock(_component_q_toggle, {
                    key: 0,
                    modelValue: cond.Positive,
                    "onUpdate:modelValue": ($event: any) => ((cond.Positive) = $event),
                    "checked-icon": "add",
                    color: "navy",
                    size: "xs",
                    label: "",
                    dense: "",
                    "unchecked-icon": "remove"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                : _createCommentVNode("", true),
              ((_ctx.theModel.Descriptor === 5 && (cond as any).CompareType || _ctx.theModel.Descriptor !== 5 && cond.Connector) && c_index > 0)
                ? (_openBlock(), _createBlock(_component_q_btn_toggle, {
                    key: 1,
                    modelValue: cond.Connector,
                    "onUpdate:modelValue": ($event: any) => ((cond.Connector) = $event),
                    class: _normalizeClass(`filter-parameter-toggle q-mt-${[2,5].includes(_ctx.theModel.Descriptor) ? 'sm' : 'sm'}`),
                    "no-caps": "",
                    unelevated: "",
                    dense: "",
                    "toggle-color": "primary",
                    color: "white",
                    "text-color": "accent",
                    options:  [
            { label: _ctx.$t('or_label'), value: 0 },
            { label: _ctx.$t('and_label'), value: 1 }
          ]
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "options"]))
                : _createCommentVNode("", true),
              ([2,3].includes((cond as any).CompareType))
                ? (_openBlock(), _createBlock(_component_q_checkbox, {
                    key: 2,
                    size: "sm",
                    class: "q-pa-none",
                    "toggle-indeterminate": "",
                    "checked-icon": "arrow_forward_ios",
                    "unchecked-icon": "arrow_back_ios",
                    "false-value": 2,
                    "true-value": 3,
                    color: "grey-7",
                    "indeterminate-value": 1,
                    "onUpdate:modelValue": [(val) => { _ctx.onCompareToggle(val, c_index) }, ($event: any) => (((cond as any).CompareType) = $event)],
                    modelValue: (cond as any).CompareType
                  }, null, 8, ["onUpdate:modelValue", "modelValue"]))
                : _createCommentVNode("", true),
              ([0,1].includes((cond as any).CompareType))
                ? (_openBlock(), _createBlock(_component_q_checkbox, {
                    key: 3,
                    "toggle-indeterminate": "",
                    "checked-icon": "drag_handle",
                    "unchecked-icon": "none",
                    color: "grey-7",
                    label: [0].includes((cond as any).CompareType) ? _ctx.$t('not_present') : '',
                    "left-label": [0].includes((cond as any).CompareType),
                    size: [0].includes((cond as any).CompareType) ? '0' : 'sm',
                    "false-value": 0,
                    "true-value": 1,
                    "indeterminate-value": 3,
                    "onUpdate:modelValue": [(val) => { _ctx.onCompareToggle(val, c_index) }, ($event: any) => (((cond as any).CompareType) = $event)],
                    modelValue: (cond as any).CompareType
                  }, null, 8, ["label", "left-label", "size", "onUpdate:modelValue", "modelValue"]))
                : _createCommentVNode("", true),
              ((cond as any).CompareType !== 0 || (cond as any).CompareType == undefined)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (!_ctx.textConditionsEditStatuses[c_index] && _ctx.theModel.Descriptor === 1)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: _normalizeClass(['cursor-pointer', 'q-mb-xs', 'q-pt-xs', 
            { 'text-grey-6': !(_ctx.conditionsModel[c_index] as SelectionTextFilterSend).Value }]),
                          style: {"margin-top":"1px"},
                          onClick: ($event: any) => (_ctx.editCondName(c_index))
                        }, _toDisplayString((_ctx.conditionsModel[c_index] as SelectionTextFilterSend).Value || _ctx.$t('empty')), 11, _hoisted_12))
                      : _createCommentVNode("", true),
                    (_ctx.textConditionsEditStatuses[c_index] && _ctx.theModel.Descriptor === 1)
                      ? (_openBlock(), _createBlock(_component_q_input, {
                          key: 1,
                          class: "thin-input full-width",
                          autofocus: "",
                          color: "grey-4",
                          debounce: "500",
                          outlined: "",
                          dense: "",
                          style: {"font-size":"14px !important","padding":"0 !important","margin-top":"2px"},
                          "hide-bottom-space": "",
                          modelValue: (_ctx.conditionsModel[c_index] as SelectionTextFilterSend).Value,
                          "onUpdate:modelValue": ($event: any) => (((_ctx.conditionsModel[c_index] as SelectionTextFilterSend).Value) = $event),
                          "no-error-icon": "",
                          rules: [(val) => !!val || _ctx.$t('input_name')],
                          onKeydown: [
                            _withKeys(($event: any) => (_ctx.textConditionsEditStatuses[c_index] = false), ["esc"]),
                            _withKeys(_withModifiers(($event: any) => (_ctx.saveCondTextModel(c_index)), ["stop","prevent"]), ["enter"])
                          ],
                          onBlur: ($event: any) => (_ctx.textConditionsEditStatuses[c_index] = false)
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "rules", "onKeydown", "onBlur"]))
                      : (_ctx.theModel.Descriptor === 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", {
                                class: _normalizeClass(["items-center", ['q-my-auto', 'cursor-pointer', 
                { 'text-grey-8': !_ctx.conditionsModel[c_index]?.Name }]]),
                                style: {"word-wrap":"break-word"}
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.conditionsModel[c_index]?.Name || _ctx.$t('not_selected_label')) + " ", 1),
                                _createVNode(_component_q_menu, {
                                  anchor: "top right",
                                  self: "bottom left",
                                  ref_for: true,
                                  ref: (el) => { _ctx.menus[c_index] = el },
                                  "max-height": "1300px"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_aux_selector, {
                                      ref_for: true,
                                      ref: "aux_selector",
                                      "model-value": [_ctx.conditionsModel[c_index]?.selected_value],
                                      "onUpdate:modelValue": (arg) => { _ctx.onUpdateStringSet(arg, c_index); },
                                      "input-index": 0,
                                      "allow-free-input": true,
                                      "allow-multiple": false,
                                      "model-type": 16,
                                      "set-id": (_ctx.theModel as SelectionParameterFilterStringSetSend).SetId,
                                      onInputValue: (val) => { _ctx.throttled(c_index, val); },
                                      onSelectorClosed: ($event: any) => (_ctx.hideMenu(c_index))
                                    }, null, 8, ["model-value", "onUpdate:modelValue", "set-id", "onInputValue", "onSelectorClosed"])
                                  ]),
                                  _: 2
                                }, 1536)
                              ], 2)
                            ])
                          ]))
                        : (_ctx.theModel.Descriptor === 3)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                              _createVNode(_component_q_option_group, {
                                dense: "",
                                inline: "",
                                multiple: "",
                                "model-value": _ctx.conditionsModel[c_index].map((el) => el.value),
                                "onUpdate:modelValue": (val) => { _ctx.changeBoolModel(val, c_index) },
                                options: _ctx.boolStatusOptions,
                                size: "xs",
                                color: "primary",
                                type: "checkbox"
                              }, null, 8, ["model-value", "onUpdate:modelValue", "options"])
                            ]))
                          : (_ctx.theModel.Descriptor === 4)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createVNode(_component_date_range_display_item, {
                                  "is-parameter": true,
                                  modelValue: _ctx.conditionsModel[c_index],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.conditionsModel[c_index]) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"])
                              ]))
                            : (_ctx.theModel.Descriptor === 5)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                  _createVNode(_component_formula_selector, {
                                    "input-parameter-options": [_ctx.fullParameterOptions],
                                    "nested-key-name": _ctx.nestedKeyName,
                                    "template-name": _ctx.templateName,
                                    "input-index": 0,
                                    modelValue: (_ctx.conditionsModel[c_index] as FormulaInFilter).FormulaTokens,
                                    "onUpdate:modelValue": ($event: any) => (((_ctx.conditionsModel[c_index] as FormulaInFilter).FormulaTokens) = $event)
                                  }, null, 8, ["input-parameter-options", "nested-key-name", "template-name", "modelValue", "onUpdate:modelValue"])
                                ]))
                              : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.theModel.Descriptor !== 3)
                ? (_openBlock(), _createBlock(_component_q_btn, {
                    key: 5,
                    class: "q-px-none q-mx-none q-mt-xs unset-items-center",
                    flat: "",
                    dense: "",
                    style: _normalizeStyle(`margin-left: 2px; margin-top: ${_ctx.conditionsModel && _ctx.conditionsModel.length && [0].includes((_ctx.conditionsModel[c_index] as any).CompareType) ? 1 : 
          ([1,2].includes(_ctx.theModel.Descriptor) ? 2 : 0)}px;`),
                    "aria-label": _ctx.$t('delete_filter'),
                    icon: "close",
                    size: "sm",
                    tabindex: "-1",
                    color: "accent",
                    onClick: ($event: any) => (_ctx.deleteCondition(c_index))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_tooltip, { delay: 1000 }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('remove')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["style", "aria-label", "onClick"]))
                : _createCommentVNode("", true)
            ], 4))
          }), 128)),
          _createElementVNode("div", _hoisted_18, [
            (_ctx.filteringOptions.length)
              ? (_openBlock(), _createBlock(_component_q_select, {
                  key: 0,
                  "model-value": _ctx.filteringOptions.find((opt) => opt.value === (_ctx.theModel as any).FilteringOption),
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = (val) => {(_ctx.theModel as any).FilteringOption = val.value}),
                  class: "full-width no-select-border thin-input",
                  "hide-bottom-space": "",
                  "bottom-slots": false,
                  dense: "",
                  outlined: "",
                  "input-debounce": "500",
                  "hide-dropdown-icon": false,
                  options: _ctx.filteringOptions
                }, null, 8, ["model-value", "options"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]))
}